import Padder from "components/Padder";
import React from "react";
import {
  MAIN_CONTENT_MAX_WIDTH,
  BACK_CONTROL_CLASS,
  STICKY_HEADER_CLASS,
  DESKTOP
} from "utils/constants/ui";
import classnames from "classnames";

const DEFAULT_CLASSES = {
  container: MAIN_CONTENT_MAX_WIDTH,
  back: BACK_CONTROL_CLASS,
  header: STICKY_HEADER_CLASS,
  content: "pa3"
};

const PresentLayout = ({
  banner,
  back,
  header,
  content,
  customClasses,
  mobileTop,
  showHeaderBorder
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <div className={classes.container}>
      {banner}
      {back && <div className={classes.back}>{back}</div>}
      {header && (
        <div
          className={classnames(`sticky__header ${classes.header}`, {
            "bb hairline-1": showHeaderBorder
          })}
        >
          {header}
          <style jsx>
            {`
              @media (max-width: ${DESKTOP}px) {
                .sticky__header {
                  top: ${Number.isInteger(mobileTop) ? mobileTop : 0}px;
                }
              }
              @media (min-width: ${DESKTOP}px) {
                .sticky__header {
                  top: 0px;
                }
              }
            `}
          </style>
        </div>
      )}
      {content && <div className={classes.content}>{content}</div>}
      <Padder theme="visible" />
    </div>
  );
};
export default PresentLayout;
